import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import routes from './routes'

Vue.use(Router)
Vue.use(Meta)

const basePath = new URL(document.getElementsByTagName('base')[0].href).pathname

const router = new Router({
  mode: 'history',
  base : basePath,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    // } else if (to.hash) {
    //   return {
    //     selector: to.hash,
    //     offset: { x: 0, y: 10 }
    //   }
    } else {
      if (to.matched.some(m => m.meta.notScrollToTop)) {
        return false
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
})

import authStore from 'src/components/Auth/store.js'

router.beforeEach((to, from, next) => {
  let requireAuth = false

  for (let match of to.matched) {
    if (match.meta.requireAuth !== undefined) requireAuth = match.meta.requireAuth
  }

  if (requireAuth) {
    if (!authStore.state.isAuth) {
      next({ path: '/forceLanding' })
      // next({
      //   path: '/login',
      //   query: { redirect: to.fullPath }
      // })
      return
    }
  }

  next()
})

export default router
